import { PROJECT_PROGRESS } from "../apiConstant";
import BaseApi from "../baseApi";

class ProjectProgressApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_PROJECT_MANAGEMENT_API_URL || "";
    this.$axiosInstance = this.initAxiosInstance();
  }

  getList(body) {
    return this.post(`${PROJECT_PROGRESS}/list`, body);
  }
}
export default ProjectProgressApi;
